import styled from "styled-components";
import SwapArrow from "../witadmin/icons/swapArrow";

export const StyledSwapArrow = styled(SwapArrow)`
    height: 14px;
    width: 14px;
`;
